export default {
  methods: {
    async render_there_left(data) {
      let xAxisData = data && data.customerTotal ? data.customerTotal.map(v=>v.dateTime) : []
      let seriesData = data && data.customerTotal ? data.customerTotal.map(v=>v.total) : []
      let option = {
        color: ['#3CA0FE'],
        title: {},
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          confine: true
        },
        legend: {
        },
        grid: {
          left: 10,
          // right: '4%',
          right: 20,
          bottom: 0,
          top: 40,
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: xAxisData,
            axisLabel: {
              color: 'rgb(135,139,160)',
              // interval: 0,
              // rotate: 45
            },
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        dataZoom: {
          type: 'inside',
          start: 0,
          end: ((window.innerWidth == 1920 ? 12 : 10)/seriesData.length)*100
        },
        series: {
          data: seriesData,
          type: 'bar'
        }
      };
      let $instance = this.$echarts.init(this.$refs['thereChats']);
      $instance.setOption(option, true);
      $instance.on('click', params => {
        this.dialogFormVisibleLeft = true
        this.leftDialog(colorArr)
      });
    }
  }
}